import React from "react";
import classnames from "classnames";

import { MiniLoadingProps } from "./types";

import "./styles.scss";

export const MiniLoading: React.FC<MiniLoadingProps> = ({ className }) => {
  return (
    <div className={classnames(className, "mini_loading fadeInSimple")}>
      <div className="flex h-full items-center justify-center">
        <div className="mini_loading__wave" />
        <div className="mini_loading__wave" />
        <div className="mini_loading__wave" />
        <div className="mini_loading__wave" />
      </div>
    </div>
  );
};
